import React from "react";
import SectionHeading from "@/components/common/SectionHeading";
import Icon from "@/components/common/Icon";
import { Stagger, StaggerItem } from "@/components/common/Reveal";
import { useSettings } from "@/context/SettingsContext";

export default function IndustriesSection({ chapter = "05" }) {
  const { industries = [] } = useSettings();
  return (
    <section className="bg-alt border-y border-[#D9E0E4]" data-testid="industries-section" id="industries">
      <div className="container-page py-20 lg:py-28">
        <SectionHeading
          chapter={chapter}
          eyebrow="Industries"
          title="Sourcing support for diverse business requirements"
          intro="Tell us your field and we will tailor the requirement review accordingly."
        />
        <Stagger className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {industries.map((ind) => (
            <StaggerItem key={ind.title}>
              <div className="group h-full bg-white border border-[#D9E0E4] rounded-lg p-6 hover:border-teal transition-colors" data-testid={`industry-${ind.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <div className="h-11 w-11 rounded-md bg-[#EAF1F4] flex items-center justify-center group-hover:bg-navy transition-colors">
                  <Icon name={ind.icon} className="h-5 w-5 text-teal group-hover:text-copper transition-colors" />
                </div>
                <h3 className="mt-5 font-heading font-semibold text-[15.5px] text-navy leading-snug">{ind.title}</h3>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
